import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ticketsCartQuery,
  type TicketsCartQueryData,
} from 'restful/tickets/queries/useTicketsCart';
import { useTicketingCartId, useTicketingEventId } from 'restful/tickets/utils';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import type { CartCreateInput } from 'services/api/restful/generated/nofomoRestApi.schemas';
import { createCart } from 'services/api/restful/generated/tickets/tickets';

export const useTicketsCreateCart = () => {
  const { setCartId } = useTicketingCartId();
  const { eventId } = useTicketingEventId();
  const queryClient = useQueryClient();

  const { isPending, isPaused, mutate } = useMutation<
    TicketsCartQueryData,
    RestApiError,
    CartCreateInput
  >({
    mutationFn: async (input) => {
      const { data } = await restCall(() => createCart(eventId, input));
      return { cart: data };
    },
    retry: false,
    onSuccess: ({ cart }) => {
      if (cart?.id) {
        queryClient.setQueryData<TicketsCartQueryData>(
          ticketsCartQuery({ eventId, cartId: cart.id }).queryKey,
          { cart },
        );
        setCartId(cart.id);
      }
    },
  });

  return {
    createCart: mutate,
    isLoading: isPending && !isPaused,
  };
};
